export const eRevoCssRules = {
  body: {
    "font-family": "Jost !important",
  },
  ".pinboard-note-tile-module__normalMode": {
    background:
      "radial-gradient(circle, rgba(250, 250, 250, 0) 0%, rgba(20, 20, 20, 0.25) 100%)",
    padding: "2.2em",
  },
  ".button-module__backgroundLight.button-module__primary": {
    "background-color": "black",
  },
  ".pinboard-module__pinboardPage": {
    background:
      "radial-gradient(circle, rgba(250, 250, 250, 0) 0%, rgba(20, 20, 20, 0.15) 100%)",
    padding: "2em",
  },
  ".classic-nav-module__topNavV1": {
    background: "black! important",
  },
};

export const appEmbedWrapperCssRules = {
  ".bk-primary-nav-home-logo": {
    display: "none !important",
  },
  ".bk-primary-nav-logo": {
    display: "none !important",
  },
  ".bk-primary-nav-home": {
    display: "none !important",
  },
  ".bk-primary-nav-admin": {
    display: "none !important",
  },
  ".bk-primary-nav-manage-data": {
    display: "none !important",
  },
  ".bk-primary-nav-insights": {
    display: "none !important",
  },
  ".bk-primary-nav-setup": {
    display: "none !important",
  },
  ".pinboard-edit-header-module__headerLogo": {
    display: "none !important",
  },
  ".pinboard-header-module__avatarDiv": {
    display: "none !important",
  },
  ".bk-logo-wide-customizable": {
    display: "none !important",
  },
  ".wizard-module__headerLogo": {
    display: "none !important",
  },
  ".bk-powered-by-ts-ribbon": {
    display: "none !important",
  },
  ".classic-nav-module__homeLink": {
    display: "none !important",
  },
  '.classic-nav-module__navItem[href="/#/insights"]': {
    display: "none !important",
  },
  '.classic-nav-module__navItem[href="/#/insights/home/monitor-alerts"]': {
    display: "none !important",
  },
  '.classic-nav-module__navItem[href="/#/data/tables"]': {
    display: "none !important",
  },
  '.classic-nav-module__navItem[href="/#/admin"]': {
    display: "none !important",
  },
  "#textarea-RequestAccessObjectNoAccess": {
    display: "none !important",
  },
  ".request-access-no-access-module__requestAccessBtn": {
    display: "none !important",
  },
  //'.pinboard-header-module__shareButton': {
  //  'display': 'none !important'
  //}
};

export const appEmbedWrapperCssRulesNoSaveView = {
  ...appEmbedWrapperCssRules,
  ".personalised-views-module__saveViewButton": {
    display: "none !important",
  },
};
